module.exports = __webpack_public_path__ + "static/lighting_bolt_2_mtg_clb-489bee1c91b0ff96f15eafac4fce4ba0.jpg";